import { FileClockIcon } from '@hugeicons/core-free-icons';
import { createIcon } from '../icon';

export const FileClock = /* @__PURE__ */ createIcon(FileClockIcon, 'FileClock');
